module.exports = __webpack_public_path__ + "img/txt.7207c3f4.png";